import { AssetImages } from "../../Constants/Assets";
import LocalStorageHelper from "./LocalStorageHelper";
import GlobalFunctionHelper from "./GlobalFunctionHelper";
import RouteHelper from "./RouteHelper";
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

const SettingsHelper = {
    getSettingsData: function () {
    	const userData = LocalStorageHelper.getUserData();
        let settingsData = {
	        favicon: AssetImages.WEB_APP_FAVICON,
	        language: "English",
            webName: StaticDisplayText.APP_NAME,
            appHeaderLine: StaticDisplayText.APP_HEADER
	    };
        
        return { data: settingsData, errorCode: (userData != null && userData != "" ? 200 : 401), isSuccess: (userData != null && userData != "" ? true : false) };
    },
    UpdateWebPageDetails: function () {
        let webName = StaticDisplayText.APP_NAME;
        let appHeaderLine = RouteHelper.getRouteDescription(window.location.pathname);
        let x70Logo = GlobalFunctionHelper.getWebAppLogo();

        let currentWebIcon = document.querySelector("link[rel~='icon']");
        let newWebIcon = document.createElement('link');
        let currentAppleWebIcon = document.querySelector("link[rel~='apple-touch-icon']");
        let newAppleWebIcon = document.createElement('link');

        newWebIcon.rel = 'icon';
        newWebIcon.href = x70Logo;
        newAppleWebIcon.rel = 'apple-touch-icon';
        newAppleWebIcon.href = x70Logo;

        if (currentWebIcon) {
            document.getElementsByTagName('head')[0].removeChild(currentWebIcon);
        }

        if (currentAppleWebIcon) {
            document.getElementsByTagName('head')[0].removeChild(currentAppleWebIcon);
        }

        document.getElementsByTagName('head')[0].appendChild(newWebIcon);
        document.getElementsByTagName('head')[0].appendChild(newAppleWebIcon);
        document.title = webName + " - " + appHeaderLine;
        
        return true;
    },
}

export default SettingsHelper;